import React, { useEffect } from "react";
import ReactGA from "react-ga";
import { useHistory } from "react-router-dom";

export default props => {
    const history = useHistory();
    useEffect(() => {
        if (process.env.VERSION !== "PROD") return;
        ReactGA.initialize("UA-145123543-1");
        ReactGA.pageview(window.location.pathname);
        history.listen(location => ReactGA.pageview(location.pathname));
    }, [history]);
    return <>{props.children}</>;
};
